import React from 'react'
import {ChatSection} from "../../../components/sections/chat/ChatSection";

export const ChatPage = () => {
  return (
      <div>
        <ChatSection/>
      </div>
  )
}
